export default __webpack_public_path__ + "static/media/rowimg02.240414ae.png";